import firebase from 'firebase/app';
import 'firebase/firestore';

export const loadFtu = async (appId, userId) => {
    let ftu = await fetchFtu(appId);

    ftu = flattenFtuForUser(ftu, userId);

    return ftu;
};

export const updateFtuItem = async (appId, userId, key, value) => {
    return updateFtu(appId, userId, { [key]: value });
};

const fetchFtu = async (appId) => {
    const docRef = firebase.firestore().collection('ftu').doc(appId);

    const doc = await docRef.get();

    return doc.exists ? { ...doc.data() } : {};
};

const updateFtu = async (appId, userId, updates) => {
    const ftu = await fetchFtu(appId);

    Object.keys(updates).forEach((key) => {
        if (ftu[key] && ftu[key][userId] === updates[key]) return;
        ftu[key] = {
            ...ftu[key],
            [userId]: updates[key],
        };
    });

    const docRef = firebase.firestore().collection('ftu').doc(appId);

    return docRef.set(ftu);
};

const flattenFtuForUser = (ftu, userId) => {
    Object.keys(ftu).forEach((key) => {
        if (typeof ftu[key] === 'object') {
            if (ftu[key][userId] !== undefined) {
                ftu[key] = ftu[key][userId];
            } else {
                delete ftu[key];
            }
        }
    });

    return ftu;
};
